import { getStore, isCloudCacheLoaded } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logCoreUsage, logUsage } from 'owa-analytics';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import { type DatapointVariant } from 'owa-analytics-types';
import { isEasiIdUser } from './isEasiIdUser';

export function isEasiIdUserWithoutCloudCache(): boolean {
    const mailboxInfo = getModuleContextMailboxInfo();

    if (!isEasiIdUser()) {
        return false;
    }

    // it is necessary to check if cloudcache is loaded before believe that we
    // have a valid information.
    if (!isCloudCacheLoaded()) {
        return false;
    }

    if (getStore().cloudCacheConfigItem.emailAddress) {
        if (isFeatureEnabled('growth-easiIdGmailCloudCacheV2')) {
            // User feature check: EASI ID user with cloud cache (V2)
            logCoreUsage('IsEasiIdGmailUserWithCloudCacheV2', mailboxInfo, undefined, {
                // this function is called more than once per session,
                // so we added this flag to log only the first datapoint
                variant: 2,
            });
        } else {
            // User feature check: EASI ID user with cloud cache
            logCoreUsage('IsEasiIdGmailUserWithCloudCache', mailboxInfo, undefined, {
                // this function is called more than once per session,
                // so we added this flag to log only the first datapoint
                variant: 2,
            });
        }

        return false;
    }

    if (isFeatureEnabled('growth-easiIdGmailCloudCacheV2')) {
        // User feature check: EASI ID user without cloud cache (V2)
        logUsage('IsEasiIdGmailUserWithoutCloudCacheV2', mailboxInfo, undefined, {
            variant: 2,
        });
    } else {
        // User feature check: EASI ID user with cloud cache
        logUsage('IsEasiIdGmailUserWithCloudCache', mailboxInfo, undefined, {
            variant: 2,
        });
    }

    return true;
}
